module.exports = "https://static.weeecdn.net/mweb/_next/static/images/benefits-bg-a7c3558ab3f037d421f1a54a9368eb90.png";